import React from 'react';
import {Link as RouterLink} from 'react-router';
import {
    Box,
    Container,
    Typography,
    Paper,
    Link,
    Divider,
    List,
    ListItem,
    ListItemIcon,
} from '@mui/material';
import {School as SchoolIcon, ArrowRight as ArrowRightIcon} from '@mui/icons-material';

const Datenschutz = () => {
    return (
        <Box sx={{position: 'relative', minHeight: '100vh', py: 8, backgroundColor: 'background.default'}}>
            <Container maxWidth="md">
                <Paper
                    elevation={3}
                    sx={{
                        p: 4,
                        backgroundColor: 'background.paper',
                    }}
                >
                    {/* Header */}
                    <Box sx={{display: 'flex', alignItems: 'center', mb: 3}}>
                        <SchoolIcon sx={{mr: 2, fontSize: 40, color: 'primary.main'}}/>
                        <Typography variant="h4" color="primary" fontWeight="bold">
                            Datenschutzerklärung
                        </Typography>
                    </Box>

                    <Divider sx={{mb: 4}}/>

                    {/* --- Start Content --- */}

                    <Typography variant="h6" gutterBottom fontWeight="medium">
                        Datenschutz auf einen Blick
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Wir freuen uns über Ihr Interesse an unserer Lernapp DuoQuanto. Der Schutz personenbezogener
                        Daten ist uns ein wichtiges Anliegen. Die Verarbeitung Ihrer Daten erfolgt ausschließlich im
                        Rahmen der gesetzlichen Vorschriften (insbesondere DSGVO, BDSG, TTDSG).
                    </Typography>

                    {/* 1. Verantwortliche Stelle */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            1. Verantwortliche Stelle
                        </Typography>
                        <Typography variant="body1">
                            Hochschule der Medien Stuttgart, diese ist eine Körperschaft des öffentlichen Rechts. Sie
                            wird durch den Rektor Professor Dr. Alexander W. Roos gesetzlich vertreten.
                        </Typography>
                        <Typography variant="body1" mt={1}>
                            <strong>Anschrift:</strong><br/>
                            Hochschule der Medien Stuttgart, Nobelstrasse 10, 70569 Stuttgart, Deutschland
                        </Typography>
                        <Typography variant="body1" mt={1}>
                            <strong>E-Mail:</strong> <Link
                            href="mailto:datenschutz@hdm-stuttgart.de">datenschutz@hdm-stuttgart.de</Link>
                        </Typography>
                    </Box>

                    {/* 2. Datenschutzbeauftragter */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            2. Datenschutzbeauftragter
                        </Typography>
                        <Typography variant="body1">
                            Datenschutzbeauftragter der Hochschule der Medien
                        </Typography>
                        <Typography variant="body1" mt={1}>
                            <strong>E-Mail:</strong> <Link
                            href="mailto:datenschutz@hdm-stuttgart.de">datenschutz@hdm-stuttgart.de</Link>
                        </Typography>
                    </Box>

                    {/* 3. Art und Zwecke der Datenverarbeitung */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            3. Art und Zwecke der Datenverarbeitung
                        </Typography>

                        <Typography variant="subtitle1" fontWeight="medium" gutterBottom mt={2}>
                            a) Allgemeine Nutzung der App
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Im Rahmen der Nutzung der Lernapp können folgende Daten zu den nachstehenden Zwecken
                            verarbeitet werden:
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">Art der Daten:</Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Zugangsdaten: Hochschul-E-Mail-Adresse</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Nutzungsdaten: Logins, Lernfortschritt, Testergebnisse,
                                    bearbeitete Aufgaben</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Technische Daten: IP-Adresse, Browsertyp, Betriebssystem,
                                    Zeitpunkt der Zugriffe</Typography>
                            </ListItem>
                        </List>
                        <Typography variant="body1" fontWeight="medium" mt={1}>Zwecke der Verarbeitung:</Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Bereitstellung der Lerninhalte und Funktionen der
                                    App</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Personalisierung (z. B. Anzeige des individuellen
                                    Lernfortschritts)</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Sicherstellung der IT-Sicherheit und
                                    Systemstabilität</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Evaluation und Verbesserung des Lehrangebots</Typography>
                            </ListItem>
                        </List>

                        <Typography variant="subtitle1" fontWeight="medium" gutterBottom mt={3}>
                            b) Analyse und Session Recording
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Wir verwenden in unserer Lern-App den Analysedienst PostHog (PostHog Inc.), um die Nutzung
                            unserer App besser zu verstehen, Fehler zu identifizieren und die Benutzerfreundlichkeit zu
                            verbessern.
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">Art der Daten:</Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Informationen über Ihre Interaktionen innerhalb der App (z.
                                    B. aufgerufene Seiten, Navigation, Klicks).</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Technische Informationen zu Ihrem Endgerät (z. B.
                                    Bildschirmgröße, Browsertyp, Betriebssystem).</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Texteingaben oder andere personenbezogene Inhalte werden
                                    automatisch maskiert und nicht aufgezeichnet.</Typography>
                            </ListItem>
                        </List>
                        <Typography variant="body1" fontWeight="medium" mt={1}>Zweck der Verarbeitung:</Typography>
                        <Typography variant="body1" paragraph>
                            Analyse des Nutzerverhaltens zur Fehleridentifikation und zur Verbesserung der
                            Benutzerfreundlichkeit.
                        </Typography>
                    </Box>

                    {/* 4. Rechtsgrundlagen */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            4. Rechtsgrundlagen
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Die Verarbeitung erfolgt auf Grundlage von:
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Art. 6 Abs. 1 lit. e DSGVO (Aufgabe im öffentlichen
                                    Interesse im Rahmen von Studium und Lehre)</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) für die Analyse
                                    und das Session Recording mit PostHog sowie für optionale Funktionen wie
                                    Umfragen.</Typography>
                            </ListItem>
                        </List>
                    </Box>

                    {/* 5. Einwilligung und Widerruf */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            5. Einwilligung und Widerruf
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Ohne Ihre Zustimmung werden keine Daten oder Events an PostHog übertragen und gespeichert.
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2"><strong>Opt-In:</strong> Bei der ersten Anmeldung können Sie
                                    der Datenverarbeitung durch PostHog aktiv zustimmen.</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2"><strong>Widerruf:</strong> Ihre Entscheidung können Sie
                                    jederzeit in den Profil-Einstellungen der App ändern und Ihre Einwilligung mit
                                    Wirkung für die Zukunft widerrufen.</Typography>
                            </ListItem>
                        </List>
                    </Box>

                    {/* 6. Cookies und lokale Speicherung */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            6. Cookies und lokale Speicherung
                        </Typography>

                        <Typography variant="subtitle1" fontWeight="medium" gutterBottom mt={2}>
                            a) Technisch notwendige lokale Speicherung für Authentifizierung
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Für die Anmeldung und Nutzung der App werden zwingend erforderliche
                            Authentifizierungsinformationen lokal auf Ihrem Endgerät gespeichert.
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Hierzu gehören insbesondere idToken, accessToken und
                                    refreshToken, die für den sicheren Zugriff auf Ihre persönlichen Inhalte benötigt
                                    werden.</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Diese Einträge sind im Local Storage durch den Präfix
                                    logto:...:tokenType erkennbar.</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">Ohne diese Speicherung ist eine Anmeldung in der App
                                    technisch nicht möglich.</Typography>
                            </ListItem>
                        </List>

                        <Typography variant="subtitle1" fontWeight="medium" gutterBottom mt={3}>
                            b) Cookies für Analysen und Session Recording
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Sofern Sie zugestimmt haben, verwendet PostHog Cookies und den Local Storage Ihres
                            Endgeräts, um Nutzer wiederzuerkennen und Sitzungen zuzuordnen.
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography
                                    variant="body2"><strong>Cookie-Name:</strong> ph_phc_mx581jPXphowdG8LaFEtztgBJf3jQi5TkJFz4PljhQw_posthog</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2"><strong>Zweck:</strong> Speicherung einer pseudonymisierten
                                    Nutzer-ID („distinct_id“), Sitzungsinformationen sowie Einstellungen zu Feature
                                    Flags.</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2"><strong>Speicherdauer:</strong> Das Cookie und die
                                    zugehörigen Daten bleiben bis zu 365 Tage gespeichert.</Typography>
                            </ListItem>
                        </List>
                    </Box>

                    {/* 7. Empfänger der Daten und Hosting */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            7. Empfänger der Daten und Hosting
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2"><strong>Intern:</strong> Zugriff auf Ihre Daten haben nur
                                    berechtigte Personen des DuoQuanto-Teams. Eine Weitergabe an Dritte erfolgt nicht,
                                    es sei denn, es besteht eine gesetzliche Verpflichtung.</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2"><strong>Hosting der App:</strong> Die App wird auf Servern
                                    betrieben, die sich in Deutschland befinden und den Vorgaben der DSGVO entsprechen.</Typography>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon fontSize="small"/></ListItemIcon>
                                <Typography variant="body2">
                                    <strong>Analyse-Dienst (PostHog):</strong> Wir nutzen PostHog Cloud mit
                                    Serverstandort in der Europäischen Union. Eine Übermittlung personenbezogener Daten
                                    in Drittländer findet nicht statt. Weitere Informationen finden Sie in der
                                    Datenschutzerklärung von PostHog: <Link href="https://posthog.com/privacy"
                                                                            target="_blank"
                                                                            rel="noopener">https://posthog.com/privacy</Link>
                                </Typography>
                            </ListItem>
                        </List>
                    </Box>

                    {/* 8. Speicherdauer */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            8. Speicherdauer
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Personenbezogene Daten werden nur so lange gespeichert, wie dies für die Nutzung der Lernapp
                            erforderlich ist. Nach Abschluss des Studiums oder nach Beendigung der Nutzung werden
                            personenbezogene Daten regelmäßig gelöscht oder anonymisiert, soweit keine gesetzlichen
                            Aufbewahrungspflichten bestehen.
                        </Typography>
                    </Box>

                    {/* 9. Ihre Rechte */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            9. Ihre Rechte
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Sie haben das Recht auf:
                        </Typography>
                        <List dense>
                            <ListItem><ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon
                                fontSize="small"/></ListItemIcon><Typography variant="body2">Auskunft (Art. 15
                                DSGVO)</Typography></ListItem>
                            <ListItem><ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon
                                fontSize="small"/></ListItemIcon><Typography variant="body2">Berichtigung (Art. 16
                                DSGVO)</Typography></ListItem>
                            <ListItem><ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon
                                fontSize="small"/></ListItemIcon><Typography variant="body2">Löschung (Art. 17
                                DSGVO)</Typography></ListItem>
                            <ListItem><ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon
                                fontSize="small"/></ListItemIcon><Typography variant="body2">Einschränkung der
                                Verarbeitung (Art. 18 DSGVO)</Typography></ListItem>
                            <ListItem><ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon
                                fontSize="small"/></ListItemIcon><Typography variant="body2">Datenübertragbarkeit (Art.
                                20 DSGVO)</Typography></ListItem>
                            <ListItem><ListItemIcon sx={{minWidth: '30px'}}><ArrowRightIcon
                                fontSize="small"/></ListItemIcon><Typography variant="body2">Widerspruch gegen die
                                Verarbeitung (Art. 21 DSGVO)</Typography></ListItem>
                        </List>
                        <Typography variant="body1" paragraph mt={1}>
                            Zur Wahrnehmung Ihrer Rechte wenden Sie sich bitte an den Datenschutzbeauftragten (s. oben).
                        </Typography>
                    </Box>

                    {/* 10. Beschwerderecht */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            10. Beschwerderecht
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Sie haben zudem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
                            Zuständig ist die/der Landesbeauftragte für Datenschutz in Baden-Württemberg.
                        </Typography>
                    </Box>

                    {/* 11. Änderungen */}
                    <Box sx={{my: 3}}>
                        <Typography variant="h6" gutterBottom fontWeight="medium">
                            11. Änderungen
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
                            rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen.
                        </Typography>
                    </Box>

                    {/* --- End Content --- */}

                    {/* Back to Home Link */}
                    <Box sx={{mt: 4, pt: 3, borderTop: 1, borderColor: 'divider'}}>
                        <Link
                            component={RouterLink}
                            to="/"
                            color="primary"
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                textDecoration: 'none',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            ← Zurück zur Startseite
                        </Link>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default Datenschutz;